const COLLAB_USER_COLORS = [
	'#e11d48',
	'#d97706',
	'#16a34a',
	'#0891b2',
	'#2563eb',
	'#7c3aed',
	'#db2777',
	'#0f766e',
] as const;

export function colorForUserId(userId: number): string {
	const n = Math.abs(Number(userId) || 0);
	return COLLAB_USER_COLORS[n % COLLAB_USER_COLORS.length];
}
